export default __webpack_public_path__ + "static/media/sweetlawcookie.01a811da.png";